import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { salesCalculateReport } from 'lib/api/sales';
import { setPortal } from 'modules/portal';
import NewTableContainer from 'components/molecules/NewTable';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewButton from 'components/molecules/NewButton';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import CalculateModal from './CalculateModal';
import numeral from 'numeral';
import { useDispatch, useSelector } from 'react-redux';

const StatisticsMobon = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  let initParams = {
    adutSvcTpCode: '01',
    sMth: moment().add(-12, 'month').format('YYYYMM'),
    eMth: moment().format('YYYYMM'),
  };
  let initModal = {
    open: false,
    type: null,
    params: {
      adutSvcTpCode: '01',
    },
    modalTitle: '',
    confirmBtnTitle: '',
    message: '',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [modal, setModal] = useState(initModal);
  const [reFetch, setReFetch] = useState(false);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const customized = {
    SALES_VAT_SEP: {
      makeHead: (headsMap) => {
        const result = { content: '', orderFlag: true };
        result.content = (
          <SpanningTableContents topTitle={t('광고매출')} type="head">
            <div style={{ width: 100 }}>{t('매출(VAT별도)')}</div>
            <div style={{ width: 100 }}>{t('매출(VAT포함)')}</div>
            <div style={{ width: 100 }}>{t('입금액')}</div>
          </SpanningTableContents>
        );
        return result;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <SpanningTableContents>
            <div style={{ width: 100 }}>
              {numeral(rowObj['SALES_VAT_SEP']).format('#,##0')}
            </div>
            <div style={{ width: 100 }}>
              {numeral(rowObj['SALES_VAT_INC']).format('#,##0')}
            </div>
            <div style={{ width: 100 }}>
              {numeral(rowObj['IN_POINT']).format('#,##0')}
            </div>
          </SpanningTableContents>
        );
      },
      orderFlag: false,
      headStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
      bodyStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
    },
    SALES_VAT_INC: {
      merged: true,
    },
    IN_POINT: {
      merged: true,
    },
    CALCUL_FEE: {
      makeHead: (headsMap) => {
        const result = { content: '', orderFlag: true };
        result.content = (
          <SpanningTableContents topTitle={t('대행수수료')} type="head">
            <div style={{ width: 100 }}>{t('수수료액')}</div>
            <div style={{ width: 100 }}>{t('수수료율')}</div>
            <div style={{ width: 100 }}>{t('실지급액')}</div>
          </SpanningTableContents>
        );
        return result;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <SpanningTableContents>
            <div style={{ width: 100 }}>
              {numeral(rowObj['CALCUL_FEE']).format('#,##0')}
            </div>
            <div style={{ width: 100 }}>
              {numeral(rowObj['CALCUL_FEE_RATE']).format('0.00%')}
            </div>
            <div style={{ width: 100 }}>
              {numeral(rowObj['RL_PYMT_AMT']).format('#,##0')}
            </div>
          </SpanningTableContents>
        );
      },
      orderFlag: false,
      headStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
      bodyStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
    },
    CALCUL_FEE_RATE: {
      merged: true,
    },
    RL_PYMT_AMT: {
      merged: true,
    },
    SALES_BILL_VAT_SEP: {
      makeHead: (headsMap) => {
        const result = { content: '', orderFlag: true };
        result.content = (
          <SpanningTableContents topTitle={t('계산서 금액(매출)')} type="head">
            <div style={{ width: 100 }}>{t('VAT별도')}</div>
            <div style={{ width: 100 }}>{t('VAT포함')}</div>
          </SpanningTableContents>
        );
        return result;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <SpanningTableContents>
            <div style={{ width: 100 }}>
              {numeral(rowObj['SALES_BILL_VAT_SEP']).format('#,##0')}
            </div>
            <div style={{ width: 100 }}>
              {numeral(rowObj['SALES_BILL_VAT_INC']).format('#,##0')}
            </div>
          </SpanningTableContents>
        );
      },
      orderFlag: false,
      headStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
      bodyStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
    },
    SALES_BILL_VAT_INC: {
      merged: true,
    },
  };

  /**
   * 테이블 컬럼 추가
   */
  const addColumnList = (() => {
    const result = new Map();
    result.set(-1, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        let resultData;
        if (data.STATS_MTH !== 'total') {
          let addParams =
            '&statsMth=' +
            data['STATS_MTH'] +
            '&adutSvcTpCode=' +
            initParams.adutSvcTpCode;
          resultData = (
            <TableBtnWrap>
              <NewButton
                name="history"
                title={t('히스토리')}
                iconBtn
                icon="faHistory"
                onClick={(e) =>
                  handlePortalUrl(
                    '/sales/calculate/history?isPop=1' + addParams
                  )
                }
                disableRipple
                style={{
                  backgroundColor: '#79bd2f',
                }}
                color="#fff"
              />
              <NewButton
                name="priceEdit"
                title={t('수정')}
                iconBtn
                icon="faEdit"
                disableRipple
                onClick={(e) => handleModalOpen(e, data)}
              />
            </TableBtnWrap>
          );
        } else {
          resultData = null;
        }
        return resultData;
      },
    });
    return result;
  })();

  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const getModalParam = (newParams) => {
    if (JSON.stringify(modal) !== JSON.stringify(newParams)) {
      setModal(newParams);
    }
  };

  /**
   * 테이블 상태를 갱신
   * @param status
   */
  const handleReFetch = (status) => {
    setReFetch(status);
  };

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = (e, data) => {
    const { name } = e.currentTarget;
    let newModal = { ...initModal };

    if (name === 'priceEdit') {
      newModal = {
        ...newModal,
        open: true,
        type: name,
        modalTitle: '실지금액 수정',
        confirmBtnTitle: '확인',
        params: {
          ...modal.params,
          statsMth: data['STATS_MTH'],
          price: data['RL_PYMT_AMT'],
          adutSvcTpCode: initParams.adutSvcTpCode,
        },
      };
    } else if (name === 'editor') {
      newModal = {
        ...newModal,
        open: true,
        type: name,
        modalTitle: 'Toast Editor',
        confirmBtnTitle: '확인',
        params: {
          ...modal.params,
        },
      };
    }

    setModal(newModal);
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal;
    newModal = {
      ...modal,
      open: false,
    };
    getModalParam(newModal);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
          useMonthDate
          useDatePresets={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={salesCalculateReport}
        params={params}
        getParam={getParam}
        customized={customized}
        reFetch={reFetch}
        useSearch={false}
        addColumnList={addColumnList}
      />
      {modal.open === true && modal.type === 'priceEdit' && (
        <CalculateModal
          modal={modal}
          handleReFetch={handleReFetch}
          getModalParam={getModalParam}
          handleModalClose={handleModalClose}
        ></CalculateModal>
      )}
    </>
  );
};

export default StatisticsMobon;
